<template>
    <div class="py-20 bg-white" id="services">
        <div class="max-w-7xl mx-auto px-4">
            <h2 class="text-3xl font-bold text-center mb-16">我们的服务</h2>
            <div class="grid grid-cols-4 gap-8">
                <div class="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300">
                    <div class="h-48 overflow-hidden">
                        <img src="https://ai-public.mastergo.com/ai/img_res/9b65401bd8f68f469c908fbe27dce84d.jpg" 
                             class="w-full h-full object-cover object-top" alt="个人心理咨询">
                    </div>
                    <div class="p-6">
                        <h3 class="text-xl font-bold mb-3">个人心理咨询</h3>
                        <p class="text-gray-600 mb-4">一对一专业咨询服务，帮助您解决情绪、压力等困扰</p>
                        <button class="btn btn-link !rounded-button whitespace-nowrap">
                            了解更多
                            <i class="fas fa-chevron-right ml-2"></i>
                        </button>
                    </div>
                </div>
                <div class="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300">
                    <div class="h-48 overflow-hidden">
                        <img src="https://ai-public.mastergo.com/ai/img_res/024a6b4cba8eed4830e15aad2eabf88a.jpg" 
                             class="w-full h-full object-cover object-top" alt="企业EAP服务">
                    </div>
                    <div class="p-6">
                        <h3 class="text-xl font-bold mb-3">企业EAP服务</h3>
                        <p class="text-gray-600 mb-4">为企业提供员工心理健康管理解决方案</p>
                        <button class="btn btn-link !rounded-button whitespace-nowrap">
                            了解更多
                            <i class="fas fa-chevron-right ml-2"></i>
                        </button>
                    </div>
                </div>
                <div class="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300">
                    <div class="h-48 overflow-hidden">
                        <img src="https://ai-public.mastergo.com/ai/img_res/3060e51a06bde5362099515078694682.jpg" 
                             class="w-full h-full object-cover object-top" alt="心理评估">
                    </div>
                    <div class="p-6">
                        <h3 class="text-xl font-bold mb-3">心理评估</h3>
                        <p class="text-gray-600 mb-4">专业的心理测评工具，帮助您了解自己</p>
                        <button class="btn btn-link !rounded-button whitespace-nowrap">
                            了解更多
                            <i class="fas fa-chevron-right ml-2"></i>
                        </button>
                    </div>
                </div>
                <div class="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300">
                    <div class="h-48 overflow-hidden">
                        <img src="https://ai-public.mastergo.com/ai/img_res/6450d6840f896680a4d78d3506504cb1.jpg" 
                             class="w-full h-full object-cover object-top" alt="团体活动">
                    </div>
                    <div class="p-6">
                        <h3 class="text-xl font-bold mb-3">团体活动</h3>
                        <p class="text-gray-600 mb-4">丰富多样的团体心理活动，促进交流与成长</p>
                        <button class="btn btn-link !rounded-button whitespace-nowrap">
                            了解更多
                            <i class="fas fa-chevron-right ml-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServiceList'
}
</script>